import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, AppBar, Typography, Toolbar, IconButton, Grid } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Chart } from 'primereact/chart';
import { dashboardHeights } from './DashboardParent';
const PREFIX = 'Impressions';

const classes = {
    title: `${PREFIX}-title`,
    appbar: `${PREFIX}-appbar`,
    notification: `${PREFIX}-notification`,
    card: `${PREFIX}-card`,
    container: `${PREFIX}-container`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.title}`]: {
		flexGrow: 1,
		fontFamily: 'calibri',
		fontWeight: 600,
		color: '#393937',
	},

    [`& .${classes.appbar}`]: {
		backgroundColor: '#F5F5F5',
		height: '50px',
		border: 'none',
	},

    [`& .${classes.notification}`]: {
		fontFamily: 'calibri',
		fontWeight: 600,
		textAlign: 'center',
		height: '100%',
	},

    [`& .${classes.card}`]: (props: any) => ({
		// marginTop: theme.spacing(2),
		height: '100%'

	}),

    [`& .${classes.container}`]: (props: any) => ({
		[theme.breakpoints.down('md')]: {
			height: 'calc(100% -  50px)',
		},
		[theme.breakpoints.down('lg')]: {
			height: 'calc(100% -  50px)',
		},
		[theme.breakpoints.down('xl')]: {
			height: 'calc(100% -  50px)',
		},
		[theme.breakpoints.down('xl')]: {
			height: 'calc(100% -  50px)',
		},
		[theme.breakpoints.up('xl')]: {
			height: 'calc(100% -  50px)',
		},
	})
}));

export interface Props {
	dateArray: Array<string>;
	actualList: Array<number>;
	potentialList: Array<number>;
}
function Impressions(props: Props) {
	const dateLabels = props.dateArray;
	const actualLabels = props.actualList;
	let actualLablesCount = 0;
	actualLabels.forEach((num: number) => {
		actualLablesCount = actualLablesCount + num;
	});

	const potentialLabels = props.potentialList;
	let potentialLabelsCount = 0;
	actualLabels.forEach((num: number) => {
		potentialLabelsCount = potentialLabelsCount + num;
	});

	const basicData = {
		labels: dateLabels,
		datasets: [
			{
				label: 'Actual Viewership Count',
				backgroundColor: '#24ee44',
				data: actualLabels,
				// data: [25, 40, 59, 70, 80, 100],
			},
			{
				label: 'Potential Viewership Count',
				backgroundColor: '#42A5F5',
				data: potentialLabels,
				// data: [25, 40, 59, 70, 80, 100],
			},
		],
	};
	const basicOptions = {
		legend: {
			labels: {
				fontColor: '#495057',
			},
		},
		scales: {
			xAxes: [
				{
					ticks: {
						fontColor: '#495057',
					},
				},
			],
			yAxes: [
				{
					ticks: {
						fontColor: '#495057',
						min: 0,
					},
				},
			],
		},
	};
	return (
        <Root>
            <Card elevation={4} className={classes.card}>
                <AppBar position="sticky" className={classes.appbar}>
                    <Toolbar>
                        <Typography variant="h3" className={classes.title}>
                            IMPRESSIONS
                        </Typography>

                        <IconButton edge="start" color="inherit" aria-label="menu" size="large">
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Grid container className={classes.container}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={8}>
                        {actualLablesCount > 0 ? (
                            <Chart className={classes.container}
                                width="80%"
                                type="bar"
                                data={basicData}
                                options={basicOptions}
                            />
                        ) : (
                            <Typography variant="h2" className={classes.notification}>
                                NO DETAILS FOR VIEWERSHIP COUNT
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={2}></Grid>
                </Grid>
            </Card>
        </Root>
    );
}

export default Impressions;
